import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <br></br>
    <br></br><br></br>
    <br></br><br></br>
    <br></br>
    <h2>{`Contact`}</h2>
    <p><a parentName="p" {...{
        "href": "https://www.linkedin.com/in/joshua-h-cheung-05351415a/"
      }}><img parentName="a" {...{
          "src": "photos/rsz_linkedin.jpg",
          "alt": "LinkedIn",
          "title": "Joshua's LinkedIn"
        }}></img></a>{`
`}{` `}{` `}<a parentName="p" {...{
        "href": "https://github.com/joshuacheung"
      }}><img parentName="a" {...{
          "src": "photos/github2.png",
          "alt": "Github Photo",
          "title": "Joshua's Github"
        }}></img></a>{`
`}{` `}{` `}<a parentName="p" {...{
        "href": "mailto:joshuacheung1598@gmail.com"
      }}>{`joshuacheung1598@gmail.com`}</a>{`
(408)-887-7743`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      